import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const DeleteLocationSlice = createSlice({
  name: "DeleteLocation",
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    deleteLocation: (state, _) => {
      state.isLoading = true;
    },
    successDeleteLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDeleteLocation: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDeleteLocation: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteLocation,
  failureDeleteLocation,
  successDeleteLocation,
  clearDeleteLocation,
} = DeleteLocationSlice.actions;

export default DeleteLocationSlice.reducer;
